<template>
    <tr v-if="o === n">
        <td style="padding: 0 5px;"></td>
        <td style="padding: 0 5px;">
            <table style="width: 100%">
                <tr>
                    <td valign="top"><div v-if="prefix !== ''" width="80" :tooltip="prefix">{{ prefix }}:</div></td>
                    <td width="100%">
                        <v-select
                            v-model="res"
                            :disabled="disabled"
                            :options="options"
                        ></v-select>
                    </td>
                    <td valign="top">{{ suffix }}</td>
                </tr>
            </table>
        </td>
        <td style="padding: 0 5px;"></td>
    </tr>
    <tr v-else>
        <td :class="{'selected': res === o}" style="padding: 0 5px;">
            <a @click="res = o">
                <template v-for="(opt, index) in options">
                        <span v-if="o === opt.value">{{opt.text}}</span>
                </template>
                <i v-if="o === ''">✕</i>
            </a>
        </td>
        <td class="selected" style="padding: 0 5px;">
            <table style="width: 100%">
                <tr>
                    <td valign="top"><div v-if="prefix !== ''" width="80" :tooltip="prefix">{{ prefix }}:</div></td>
                    <td width="100%">
                        <v-select
                            v-model="res"
                            :disabled="disabled"
                            :options="options"
                        ></v-select>
                    </td>
                    <td valign="top">{{ suffix }}</td>
                </tr>
            </table>
        </td>
        <td :class="{'selected': res == n}" style="padding: 0 5px;">
            <a @click="res = n">
                <template v-for="(opt, index) in options">
                    <span v-if="n === opt.value">{{opt.text}}</span>
                </template>
                <i v-if="n === ''">✕</i>
            </a>
        </td>
    </tr>
</template>
<script>
import Base from "../Base.vue";
import StrPropsFNO from "../StrPropsFNO.vue";
export default {
    mixins:[Base,StrPropsFNO],
    data: function () {
        return {
            suffix: this.params.suffix ?? '',
            prefix: this.params.prefix ?? '',
        }
    },
}
</script>
